import {Value} from "./value";
import {UnitType} from "./unitType";

export class Seconds extends Value {
    constructor(value: number) {
        super(value, UnitType.SECONDS);
    }
}
